<script setup>
import TheTooltip from '@shared-components/ui/TheTooltip.vue'
</script>

<template>
  <the-tooltip position="top" class="me-2"
    >The Process Owner is the person responsible for the current process. Reach out to them on Slack if you have any
    questions or suggestions for improvement.
  </the-tooltip>
  Process Owner - <span class="fw-bold"><slot /></span>
</template>
